module.exports = __webpack_public_path__ + "static/img/main-case.dc420232.png";